import _ from 'underscore';

const iconRight = ['glyphicon', 'toolbar-icon', 'grid-expand-icon', 'pull-right'];

export const supportedEntities = {
  Campaign: 'Campaign',
  AdGroup: 'AdGroup',
  Keyword: 'Keyword',
  Ad: 'Ad',
};

function getMetadata(i18n) {
  const metadata = {
    Campaign: {
      header: i18n.getString('AutomatedRules_RuleTemplatesButton_Campaign_Header'),
      body: [
        {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Campaign_ChangeBudget'),
          value: 'CampaignsGrid_automateRule_Campaign_ChangeBudget',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Campaign_PauseCampaign'),
          value: 'CampaignsGrid_automateRule_Campaign_Pause',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Campaign_EnableCampaign'),
          value: 'CampaignsGrid_automateRule_Campaign_Enable',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Campaign_SendEmail'),
          value: 'CampaignsGrid_automateRule_Campaign_SendEmail',
        },
      ],
      switchMenuOrder: [supportedEntities.AdGroup, supportedEntities.Keyword, supportedEntities.Ad],
    },
    AdGroup: {
      header: i18n.getString('AutomatedRules_RuleTemplatesButton_AdGroup_Header'),
      body: [
        {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_AdGroup_ChangeBid'),
          value: 'AdGroupGrid_automateRule_AdGroup_ChangeBid',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_AdGroup_PauseAdGroup'),
          value: 'AdGroupGrid_automateRule_AdGroup_Pause',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_AdGroup_EnableAdGroup'),
          value: 'AdGroupGrid_automateRule_AdGroup_Enable',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_AdGroup_SendEmail'),
          value: 'AdGroupGrid_automateRule_AdGroup_SendEmail',
        },
      ],
      switchMenuOrder: [supportedEntities.Keyword,
        supportedEntities.Ad, supportedEntities.Campaign],
    },
    Ad: {
      header: i18n.getString('AutomatedRules_RuleTemplatesButton_Ad_Header'),
      body: [
        {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Ad_PauseAd'),
          value: 'AdGrid_automateRule_Ad_Pause',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Ad_EnableAds'),
          value: 'AdGrid_automateRule_Ad_Enable',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Ad_SendEmail'),
          value: 'AdGrid_automateRule_Ad_SendEmail',
        },
      ],
      switchMenuOrder: [supportedEntities.Keyword,
        supportedEntities.AdGroup, supportedEntities.Campaign],
    },
    Keyword: {
      header: i18n.getString('AutomatedRules_RuleTemplatesButton_Keyword_Header'),
      body: [
        {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Keyword_ChangeBid'),
          value: 'KeywordGrid_automateRule_Keyword_ChangeBid',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Keyword_RaiseToTopOfPage'),
          value: 'KeywordGrid_automateRule_Keyword_RaiseToTopOfPage',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Keyword_RaiseToFirstPage'),
          value: 'KeywordGrid_automateRule_Keyword_RaiseToFirstPage',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Keyword_PauseKeyword'),
          value: 'KeywordGrid_automateRule_Keyword_Pause',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Keyword_EnableKeyword'),
          value: 'KeywordGrid_automateRule_Keyword_Enable',
        }, {
          key: i18n.getString('AutomatedRules_RuleTemplatesTitle_Keyword_SendEmail'),
          value: 'KeywordGrid_automateRule_Keyword_SendEmail',
        },
      ],
      switchMenuOrder: [supportedEntities.Ad,
        supportedEntities.AdGroup, supportedEntities.Campaign],
    },
  };

  return metadata;
}

const divider = {
  type: 'dropdown-divider',
};

function getMenuItemConfig(text, onClick, isFallbackEnabled = false, siteMapId = null) {
  return {
    text, onClick, isFallbackEnabled, siteMapId,
  };
}

export function getRulesMenu(
  entity,
  render, switchTo, selectInfo, i18n, isForVNext, shouldBeDisabled = false,
  isFallbackEnabled = false
) {
  const metadata = getMetadata(i18n);
  const items = [];
  const ret = {
    type: 'dropdown',
    id: 'dropdown-automate',
    iconLeftGlyphName: 'ba-LightningBolt',
    classes: ['nowrap'],
    button: {
      text: i18n.getString('AutomatedRules_RuleTemplatesButton_AutomateRule'),
      classes: ['btn', 'btn-secondary'],
      disabled: shouldBeDisabled,
    },
    menu: {
      items,
    },
  };

  items.push({
    type: 'dropdown-header',
    text: metadata[entity].header,
  });
  _.each(metadata[entity].body, ({ key, value }) => {
    items.push(getMenuItemConfig(key, render(value)));
  });
  items.push(divider);

  if (!isForVNext) {
    let subMenu = metadata[entity].switchMenuOrder;

    if (!_.isNull(selectInfo.campaignId)) {
      subMenu = _.without(subMenu, supportedEntities.Campaign);
    }
    if (!_.isNull(selectInfo.adGroupId)) {
      subMenu = _.without(subMenu, supportedEntities.AdGroup);
    }
    _.each(subMenu, (en) => {
      const subItems = _.map(
        metadata[en].body,
        ({ key, value }) => getMenuItemConfig(key, switchTo(value))
      );

      items.push({
        type: 'dropdown-submenu',
        button: {
          text: metadata[en].header,
          iconRight,
        },
        menu: {
          items: subItems,
        },
      });
    });

    items.push(divider);
  }

  items.push(getMenuItemConfig(
    i18n.getString('AutomatedRules_RuleTemplatesButton_RedirectToREManagement'),
    render('AdGroupGrid_automateRule_RedirectToREManagement'),
    isFallbackEnabled,
    'rules'
  ));

  return ret;
}
